export const FIELD_LABEL = {
  EMAIL: 'login.fieldLabel.email',
  PASSWORD: 'login.fieldLabel.password',
};

export const FIELD_PLACEHOLDER = {
  EMAIL: 'login.placeholder.email',
  PASSWORD: 'login.placeholder.password',
};
export const FIELD_VALIDATION = {
  INCORRECT_FORMAT: {
    EMAIL: 'login.validation.incorrectFormat.email',
  },
};
export const EDGE_CASE = {
  INCORRECT_CREDENTIALS: 'login.edgeCase.incorrectCredentials',
  MANY_ATTEMPTS: 'login.edgeCase.manyAttempts',
  PASSWORD_EXPIRED: 'login.edgeCase.passwordExpired',
};

export const FIELD_NAME = {
  EMAIL: 'email',
  PASSWORD: 'password',
};
export const BUTTON = {
  DOWNLOAD_APP: 'login.download.link',
};

export const AUTHORIZATION_ACTIONS = {
  MANAGE_EMMPLOYEES: 'manage_employees',
  MANAGE_COMPANY: 'manage_company',
  VIEW_WEB_BOOKING: 'view_gewebbooking',
  GE_OPERATOR: 'create_gewebboking',
  GE_ADMIN: 'assign_gewebbooking',
};

export const INACESSIBLE_LOGIN_MODAL = {
  HEADING: 'login.linkFailedModal.heading',
  LINK_FAILED_ADMIN_CONTENT: 'login.linkFailedModal.linkFailed.isAdmin.content',
  LINK_FAILED_USER_CONTENT: 'login.linkFailedModal.linkFailed.isUser.content',
  LINK_FAILED_TRY_AGAIN: 'login.linkFailedModal.linkFailed.tryAgain',
  MISSING_PERMISSION_ADMIN_CONTENT:
    'login.linkFailedModal.missingPermission.isAdmin.content',
  MISSING_PERMISSION_USER_CONTENT:
    'login.linkFailedModal.missingPermission.isUser.content',
  MISSING_PERSSION_OK: 'login.linkFailedModal.missingPermission.ok',
  NO_ASSOCIATED_COMPANY_CONTENT:
    'login.linkFailedModal.noAssociatedCompany.content',
  NO_USER_FOUND: 'login.linkFailedModal.noUserFound.content',
};

export const LOGIN_ERR_TEXT = {
  AUTH_FAILED: EDGE_CASE.INCORRECT_CREDENTIALS,
  PASSWORD_EXPIRED: EDGE_CASE.PASSWORD_EXPIRED,
};

export const LOGIN_ERRORS = {
  noAssociatedCompany: 'noAssociatedCompany',
  isLinkingFailed: 'isLinkingFailed',
  noUserFound: 'noUserFound',
  preConditionFailed: 'pre_condition_failed',
};
